import TreeNodeModel from 'models/TreeNode';
import { observable, computed } from 'mobx';
import { serialize, deserialize } from 'serializers/TnvedNode';

export default class TnvedNode extends TreeNodeModel {

  @observable id
  @observable parentId
  @observable chapter
  @observable code
  @observable description
  @observable shortDescription
  @observable duty
  @observable free_trade_zone_agreements
  @observable duty_sng
  @observable fromDate
  @observable toDate
  @observable iscode
  @observable level
  @observable unitCode
  @observable unitName

  @computed get store() {
    return this.rootStore.tnvedTreeStore;
  }

  parse(json) {
    return deserialize(json);
  }

  toJSON() {
    return serialize(this);
  }

}



// WEBPACK FOOTER //
// ./src/models/TnvedNode.js